import { createAction } from 'typesafe-actions';

export const setNetworkErrorAction = createAction('@ERROR/SETNETWORK_ERROR')();
export const setErrorAction = createAction('@ERROR/SET_ERROR')<boolean>();
export const setWppErrorAction = createAction('@ERROR/SETWPP_ERROR')<boolean>();
